module.exports = __webpack_public_path__ + "static/media/Grupo 13622.ffb3904a.svg";